import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodeceptjsComponent } from './simple-icons-codeceptjs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodeceptjsComponent ],
    exports:      [ SimpleIconsCodeceptjsComponent ],
    bootstrap:    []
})
export class SimpleIconsCodeceptjsModule {}
